import { NgModule } from '@angular/core';
import { ContratoRoutingModule } from './contrato-routing.module';

@NgModule({
  imports: [
    ContratoRoutingModule
  ],
})
export class ContratoModule { }
